import React, { useState, useEffect } from 'react';
import Sidebar from '../Sidebar';
import {
  Card,
  Col,
  Container,
  Row,
  Button,
  InputGroup,
  Form,
} from 'react-bootstrap';
import DashboardHeader from '../DashboardHeader';
import '../css/Dashboard.css';
import '../css/Dashboardlight.css';
import '../css/Custom.css';
import DashboardFooter from '../DashboardFooter';
import config from '../../../config/config';
import { getLiquidityFormDetailsById } from '../../../Action/action';
import { useParams, useNavigate } from 'react-router-dom';
import Web3WalletProvider from '../../../ConnectWallet/walletProvider';
import { useAccount } from 'wagmi';
import {
  ApproveToken,
  getTokenPriceSwap,
  PoolBalances,
  getUserTokenBalance,
  getUserUsdtBalance,
  getUserTokenBalance2,
  ApproveUsdtToken,
  ReceivableUsdt,
  ReceivableToken,
  SwapTokenToUsdt,
  SwapUsdtToToken,
} from '../../../Web3/Liquidity/swapConnector';
import { showLoader, hideLoader } from '../../loader';
import ReadMore from '../../readmore';
import { GrSync } from 'react-icons/gr';

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';
import { toast, Toaster } from 'react-hot-toast';

const Swap = ({ special, clearModalData }) => {
  const { id } = useParams();
  const [form, setForm] = useState([]);
  //const navigate = useNavigate();
  const _useWeb3WalletProvider = Web3WalletProvider();
  const { address, isConnected } = useAccount();
  const [isProviderLoaded, setisProviderLoaded] = useState(false);
  const [swapLoading, setSwapLoading] = useState(false);
  const [usdt, setUsdt] = useState(0);
  const [token, setToken] = useState(0);
  const [isUsdtFirst, setIsUsdtFirst] = useState(true);
  const [toTreasury, setToTreasury] = useState(false);
  const [priceData, setPriceData] = useState([]);
  const [percentageChange, setPercentageChange] = useState(0);
  const [error, setError] = useState('');
  const [lowerBound, setLowerBound] = useState(0);
  const [upperBound, setUpperBound] = useState(0);
  const [ticks, setTicks] = useState(0);
  const [connectWalletNow, setconnectWalletNow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isProviderLoaded) {
      _useWeb3WalletProvider.then((data) => {
        if (data) {
          setisProviderLoaded(true);
        }
      });
    }
  }, [_useWeb3WalletProvider]);

  useEffect(() => {
    if (isProviderLoaded) {
      //console.log("PTROO", isProviderLoaded);
      getFormData();
    }
  }, [isProviderLoaded]);

  const getFormData = async () => {
    try {
      const response = await getLiquidityFormDetailsById({ id });
      console.log('FORM', response);
      if (response.success) {
        if (response.data.length > 0) {
          let pb = await PoolBalances(response.data);
          response.data[0].BALANCES = pb.data[0];

          let tp = await getTokenPriceSwap(response.data);
          //      console.log("bala",tp)
          let PP = tp.data[0];
          let OP = response.data[0].usdt_amount / response.data[0].liquidity;
          response.data[0].PRICE = tp.data[0];
          const newData = [];
          const startTime = new Date().getTime() - 60 * 60 * 1000;
          newData.push({
            time: new Date(startTime).toISOString(),
            price: OP,
          });
          const steps = 5;
          const stepVariation = ((PP - OP) / (steps - 1)).toFixed(5);
          for (let i = 0; i < steps; i++) {
            const variation = OP + stepVariation * i;
            const stepTime = new Date(
              startTime + i * ((new Date().getTime() - startTime) / (steps - 1))
            ).toISOString();
            newData.push({
              time: stepTime,
              price: variation,
            });
          }
          const firstPrice = parseFloat(newData[0].price);
          const lastPrice = parseFloat(newData[newData.length - 1].price);
          const change = (
            ((lastPrice - firstPrice) / firstPrice) *
            100
          ).toFixed(2);
          setPriceData(newData);
          setPercentageChange(change);

          const prices = newData.map((point) => point.price);
          const deviation = Math.max(
            Math.abs(Math.max(...prices) - OP),
            Math.abs(Math.min(...prices) - OP)
          );

          const lowerBound = (OP - deviation).toFixed(5);
          const upperBound = (OP + deviation).toFixed(5);
          setLowerBound(lowerBound);
          setUpperBound(upperBound);

          const numTicks = 8;
          const tickStep = ((upperBound - lowerBound) / (numTicks - 1)).toFixed(
            5
          );
          const ticks = Array.from(
            { length: numTicks },
            (_, i) => parseFloat(lowerBound) + i * tickStep
          );
          setTicks(ticks);

          let balUsdt = await WalletUsdtBalance(response.data[0]);
          response.data[0].BALANCEUSDT = balUsdt;

          let balToken = await WalletTokenBalance(response.data[0]);
          response.data[0].BALANCETOKEN = balToken;

          let uData = await ExpectedUsdt(response.data[0], 0);
          response.data[0].usdtData = uData;
          console.log('UUUU', uData);

          let uToken = await ExpectedToken(response.data[0], 0);
          response.data[0].tokenData = uToken;
        }
        setForm(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formatTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const WalletUsdtBalance = async (formData) => {
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        usdtAddress: formData.usdtContract,
        pairContractAddress: formData.pairContractAddress,
        networkId: formData.chainNetworkId,
      };
      let usdtBal = await getUserUsdtBalance(request);
      return usdtBal.balance;
    } catch (error) {
      console.log('Error getting wallet usdt balance', error);
    }
  };

  const WalletTokenBalance = async (formData) => {
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        pairContractAddress: formData.pairContractAddress,
        tokenAddress: formData.token_address,
        networkId: formData.chainNetworkId,
      };
      let tokenBal = await getUserTokenBalance2(request);
      return tokenBal.balance;
    } catch (error) {
      console.log('Error getting wallet token balance', error);
    }
  };

  const ExpectedUsdt = async (formData, _token) => {
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        pairContractAddress: formData.pairContractAddress,
        tokenAddress: formData.token_address,
        tokenAmount: _token,
        networkId: formData.chainNetworkId,
      };
      let res = await ReceivableUsdt(request);
      if (res.length > 0) {
        return res[0].data;
      }
    } catch (error) {
      console.log('Error getting expected usdt', error);
    }
  };

  const ExpectedToken = async (formData, _usdt) => {
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        pairContractAddress: formData.pairContractAddress,
        tokenAddress: formData.token_address,
        usdtAddress: formData.usdtContract,
        usdtAmount: _usdt,
        networkId: formData.chainNetworkId,
      };
      let res = await ReceivableToken(request);
      //  console.log("EUR", res);
      if (res.length > 0) {
        return res[0].data;
      }
    } catch (error) {
      console.log('Error getting expected token', error);
    }
  };

  // const handleUsdtToTokenSwap = async () => {
  //   if (!isConnected) {
  //     toast.error('Please connect your wallet.');
  //     setconnectWalletNow(true);
  //     return;
  //   }
  //   try {
  //     setSwapLoading(true);
  //     showLoader();
  //     let request = {
  //       walletProvider: _useWeb3WalletProvider,
  //       pairContractAddress: form.length > 0 ? form[0].pairContractAddress : '',
  //       usdtAddress: form.length > 0 ? form[0].usdtContract : '',
  //       tokenAddress: form.length > 0 ? form[0].token_address : '',
  //       usdtAmount: usdt,
  //       networkId: form.length > 0 ? form[0].chainNetworkId : '',
  //     };
  //     let usdtApp = await ApproveUsdtToken(request);
  //     //console.log("usdt app", usdtApp);
  //     if (usdtApp.status) {
  //       let swap = await SwapUsdtToToken(request);
  //       //console.log("swapres", swap);
  //       if (swap.status) {
  //         toast.success(swap.message);
  //         setUsdt('');
  //         setToken('');
  //         setSwapLoading(false);
  //         setTimeout(() => {
  //           window.location.reload();
  //         }, 5000);
  //       } else {
  //         setSwapLoading(false);
  //         toast.error(swap.message);
  //         setUsdt('');
  //         setToken('');
  //       }
  //     } else {
  //       toast.error(usdtApp.message);
  //       setUsdt('');
  //       setToken('');
  //     }
  //   } catch (error) {
  //     console.log('usdt to token Swap error', error);
  //     setUsdt('');
  //     setToken('');
  //   } finally {
  //     hideLoader();
  //     setSwapLoading(false);
  //   }
  // };

  const handleUsdtToTokenSwap = async () => {
    if (!isConnected) {
      toast.error('Please connect your wallet.');
      setconnectWalletNow(true);
      return;
    }

    try {
      setSwapLoading(true);
      showLoader();

      const request = {
        walletProvider: _useWeb3WalletProvider,
        pairContractAddress: form.length > 0 ? form[0].pairContractAddress : '',
        usdtAddress: form.length > 0 ? form[0].usdtContract : '',
        tokenAddress: form.length > 0 ? form[0].token_address : '',
        usdtAmount: usdt,
        networkId: form.length > 0 ? form[0].chainNetworkId : '',
      };

      // Step 1: USDT Approval
      const usdtApp = await ApproveUsdtToken(request);
      if (!usdtApp.status) {
        toast.error(usdtApp.message || 'USDT approval failed');
        setUsdt('');
        setToken('');
        return;
      }

      if (!usdtApp.alreadyApproved) {
        toast.success('USDT approved successfully');
      }

      // Step 2: Perform Swap
      const swap = await SwapUsdtToToken(request);
      if (swap.status) {
        toast.success(swap.message);
        setUsdt('');
        setToken('');
        setTimeout(() => {
          window.location.reload();
        }, 5000);
      } else {
        toast.error(swap.message || 'Swap failed');
        setUsdt('');
        setToken('');
      }
    } catch (error) {
      console.error('USDT to Token Swap Error:', error);
      toast.error('Unexpected error during swap');
      setUsdt('');
      setToken('');
    } finally {
      hideLoader();
      setSwapLoading(false);
    }
  };

  // const handleTokenToUsdtSwap = async () => {
  //   if (!isConnected) {
  //     toast.error('Please connect your wallet.');
  //     setconnectWalletNow(true);
  //     return;
  //   }
  //   try {
  //     setSwapLoading(true);
  //     showLoader();
  //     let request = {
  //       walletProvider: _useWeb3WalletProvider,
  //       pairContractAddress: form.length > 0 ? form[0].pairContractAddress : '',
  //       usdtAddress: form.length > 0 ? form[0].usdtContract : '',
  //       tokenAddress: form.length > 0 ? form[0].token_address : '',
  //       tokenAmount: token,
  //       toTreasury: toTreasury,
  //       networkId: form.length > 0 ? form[0].chainNetworkId : '',
  //     };
  //     let tokenApp = await ApproveToken(request);
  //     if (tokenApp.status) {
  //       //console.log("swapreq", request);
  //       let swap = await SwapTokenToUsdt(request);
  //       //console.log("swap", swap);
  //       if (swap.status) {
  //         toast.success(swap.message);
  //         setUsdt('');
  //         setToken('');
  //         setSwapLoading(false);
  //         setTimeout(() => {
  //           window.location.reload();
  //         }, 5000);
  //       } else {
  //         setSwapLoading(false);
  //         toast.error(swap.message);
  //         setUsdt('');
  //         setToken('');
  //       }
  //     } else {
  //       toast.error(tokenApp.message);
  //       setUsdt('');
  //       setToken('');
  //     }
  //     setUsdt('');
  //     setToken('');
  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 5000);
  //   } catch (error) {
  //     console.log('token to usdt Swap error', error);
  //     setUsdt('');
  //     setToken('');
  //   } finally {
  //     hideLoader();
  //     setSwapLoading(false);
  //   }
  // };

  const handleTokenToUsdtSwap = async () => {
    if (!isConnected) {
      toast.error('Please connect your wallet.');
      setconnectWalletNow(true);
      return;
    }

    try {
      setSwapLoading(true);
      showLoader();

      const request = {
        walletProvider: _useWeb3WalletProvider,
        pairContractAddress: form.length > 0 ? form[0].pairContractAddress : '',
        usdtAddress: form.length > 0 ? form[0].usdtContract : '',
        tokenAddress: form.length > 0 ? form[0].token_address : '',
        tokenAmount: token,
        toTreasury: toTreasury,
        networkId: form.length > 0 ? form[0].chainNetworkId : '',
      };

      // Step 1: Token Approval
      const tokenApp = await ApproveToken(request);
      if (!tokenApp.status) {
        toast.error(tokenApp.message || 'Token approval failed');
        return;
      }

      if (!tokenApp.alreadyApproved) {
        toast.success('Token approved successfully');
      }

      // Step 2: Swap
      const swap = await SwapTokenToUsdt(request);
      if (swap.status) {
        toast.success(swap.message);
        setUsdt('');
        setToken('');
        setTimeout(() => {
          window.location.reload();
        }, 5000);
      } else {
        toast.error(swap.message || 'Swap failed');
      }
    } catch (error) {
      console.error('Token to USDT Swap error:', error);
      toast.error('Unexpected error during token to USDT swap');
    } finally {
      hideLoader();
      setSwapLoading(false);
    }
  };

  const onchangehandlerUsdt = async (e) => {
    e.preventDefault();
    let newUsdt = e.target.value;
    if (newUsdt < 0) {
      setError(`Amount cannot be zero or negative`);
      setUsdt('');
      return;
    } else {
      setError('');
    }
    setUsdt(newUsdt);
    let newForm = [...form];
    let res = await ExpectedToken(newForm[0], newUsdt);
    console.log('expected res', res);
    newForm[0].tokenData = res;
    setForm(newForm);
  };

  const onchangehandlerToken = async (e) => {
    e.preventDefault();
    let newToken = e.target.value;
    if (newToken < 0) {
      setError(`Amount cannot be zero or negative`);
      setToken('');
      return;
    } else {
      setError('');
      setToken(newToken);
      let updatedForm = [...form];
      let res = await ExpectedUsdt(updatedForm[0], newToken);
      console.log('newres', updatedForm[0], newToken, res);
      updatedForm[0].usdtData = res;
      //console.log("Impact", form[0].BALANCES.USDT, res.USDT);
      setForm(updatedForm);
    }
  };

  const handleToggle = (e) => {
    setToTreasury((prev) => !prev);
  };

  const changeCoins = (e) => {
    setError('');
    setToken('');
    setUsdt('');
    setIsUsdtFirst(!isUsdtFirst);
  };

  const isZero = Math.abs(percentageChange) < 0.0001;

  return (
    <>
      <Toaster />
      <div
        className="dashboard w-100 "
        style={{ minHeight: '100vh', overflow: 'hidden' }}
      >
        <div className="d-flex  w-100 h-100">
          <Sidebar special={special} clearModalData={clearModalData} />

          <div className="w-100" style={{ height: '100%' }}>
            <DashboardHeader />
            <div className="main-panel">
              <div
                className="content-wrapper px-4 px-lg-4"
                style={{
                  // padding: "15px",
                  flex: '1',
                  backgroundColor: '#000',
                  color: '#ffffff',
                  height: '100%',
                  overflowY: 'auto',
                }}
              >
                {isLoading ? (
                  <div className="p-sm-4 text-center">
                    <img
                      src={`${config.baseUrl}images/loader.gif`}
                      width="30px"
                      alt=""
                    />
                  </div>
                ) : (
                  <Row className="gy-3 pt-4">
                    {form.length > 0 && (
                      <Col
                        xxl={9}
                        xl={9}
                        lg={12}
                        md={12}
                        sm={12}
                        className="mb-4"
                      >
                        <Card className="dashboard-card dash-gradient2 overflow-hidden d-flex">
                          <Card.Body className="">
                            <Row className="align-items-center">
                              <Col lg={3} md={3} sm={3} className="mb-3">
                                <div className=" d-icon text-center">
                                  <img
                                    src={`${config.imagePath}${form[0].brand_logo}`}
                                    alt=""
                                    className="img-fluid object-fit-contain"
                                  />
                                </div>
                              </Col>
                              <Col lg={9} md={9} sm={9} className="mb-3">
                                <div className="">
                                  <Row className="align-items-center">
                                    <Col lg={8} md={8} sm={8}>
                                      <h5 className="text-white mb-xxl-2 lh-base">
                                        {form[0].token_name}{' '}
                                        <img
                                          src={`${config.imagePath}${form[0].chainName}.png`}
                                          alt=""
                                          width={35}
                                        />
                                      </h5>
                                      <p className="mb-0 text-light-grey small">
                                        {form[0].description.length > 100 ? (
                                          <p>
                                            <ReadMore
                                              text={form[0].description}
                                              maxLength={100}
                                            />
                                          </p>
                                        ) : (
                                          <p>{form[0].description}</p>
                                        )}
                                      </p>
                                    </Col>
                                    <Col lg={4} md={4} sm={4}>
                                      <div>
                                        <Button
                                          variant="outline-primary"
                                          className="w-100 mb-3 rounded-5 bg-transparent"
                                          href={`${form[0].website}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          Website
                                        </Button>
                                        <Button
                                          variant="outline-primary"
                                          className="w-100 rounded-5 bg-transparent"
                                          href={`${form[0].whitepaper}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          Whitepaper
                                        </Button>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                            <hr className="mt-0" />
                            <div>
                              <Row>
                                <Col
                                  lg={3}
                                  md={4}
                                  sm={6}
                                  xs={6}
                                  className="mb-3"
                                >
                                  <div>
                                    <small className="text-light-grey2">
                                      Current Token Liquidity
                                    </small>
                                    <p className="text-white mb-0">
                                      {form[0].BALANCES.Token.toFixed(6) || ''}{' '}
                                    </p>
                                  </div>
                                </Col>
                                <Col
                                  lg={3}
                                  md={4}
                                  sm={6}
                                  xs={6}
                                  className="mb-3"
                                >
                                  <div>
                                    <small className="text-light-grey2">
                                      Current USDT Liquidity
                                    </small>
                                    <p className="text-white mb-0">
                                      {form[0].BALANCES.USDT.toFixed(6) || ''}
                                    </p>
                                  </div>
                                </Col>
                                <Col
                                  lg={3}
                                  md={4}
                                  sm={6}
                                  xs={6}
                                  className="mb-3"
                                >
                                  <div>
                                    <small className="text-light-grey2">
                                      Current Token Price
                                    </small>
                                    <p className="text-white mb-0">
                                      ${form[0].PRICE.toFixed(6) || 0}
                                    </p>
                                  </div>
                                </Col>
                                <Col
                                  lg={3}
                                  md={4}
                                  sm={6}
                                  xs={6}
                                  className="mb-3"
                                >
                                  <div>
                                    <small className="text-light-grey2">
                                      Start Date
                                    </small>
                                    <p className="text-white mb-0">
                                      {' '}
                                      {
                                        new Date(form[0].create_at)
                                          .toISOString()
                                          .split('T')[0]
                                      }
                                    </p>
                                  </div>
                                </Col>
                                {form.length > 0 && (
                                  <Col
                                    lg={3}
                                    md={4}
                                    sm={6}
                                    xs={6}
                                    className="mb-3"
                                  >
                                    <div>
                                      <small className="text-light-grey2">
                                        Initial Token Liquidity
                                      </small>
                                      <p className="text-white mb-0">
                                        {form[0].liquidity.toFixed(6) || ''}
                                      </p>
                                    </div>
                                  </Col>
                                )}
                                <Col
                                  lg={3}
                                  md={4}
                                  sm={6}
                                  xs={6}
                                  className="mb-3"
                                >
                                  <div>
                                    <small className="text-light-grey2">
                                      Initial Usdt Liquidity
                                    </small>
                                    <p className="text-white mb-0">
                                      {form[0].usdt_amount.toFixed(6) || ''}
                                    </p>
                                  </div>
                                </Col>
                                <Col
                                  lg={3}
                                  md={4}
                                  sm={6}
                                  xs={6}
                                  className="mb-3"
                                >
                                  <div>
                                    <small className="text-light-grey2">
                                      Initial Token Price:
                                    </small>
                                    <p className="text-white mb-0">
                                      $
                                      {(
                                        form[0].usdt_amount / form[0].liquidity
                                      ).toFixed(6) || ''}
                                    </p>
                                  </div>
                                </Col>
                                <Col
                                  lg={3}
                                  md={4}
                                  sm={6}
                                  xs={6}
                                  className="mb-2"
                                >
                                  <div>
                                    <small className="text-light-grey2">
                                      Token Address
                                    </small>
                                    <p className="text-white">
                                      <a
                                        href={`${form[0].chainExplorerUrl}/address/${form[0].token_address}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {form[0].token_address
                                          .toString()
                                          .substring(0, 4) +
                                          '....' +
                                          form[0].token_address
                                            .toString()
                                            .substring(
                                              form[0].token_address.length - 4,
                                              form[0].token_address.length
                                            )}
                                      </a>{' '}
                                      <span
                                        className="copyIcon"
                                        onClick={() =>
                                          navigator.clipboard.writeText(
                                            form[0].token_address
                                          )
                                        }
                                        style={{ cursor: 'pointer' }}
                                        title="Copy to clipboard"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          viewBox="0 0 24 25"
                                          fill="none"
                                        >
                                          <path
                                            d="M5 15.5C4.06812 15.5 3.60218 15.5 3.23463 15.3478C2.74458 15.1448 2.35523 14.7554 2.15224 14.2654C2 13.8978 2 13.4319 2 12.5V5.7C2 4.5799 2 4.01984 2.21799 3.59202C2.40973 3.21569 2.71569 2.90973 3.09202 2.71799C3.51984 2.5 4.0799 2.5 5.2 2.5H12C12.9319 2.5 13.3978 2.5 13.7654 2.65224C14.2554 2.85523 14.6448 3.24458 14.8478 3.73463C15 4.10218 15 4.56812 15 5.5M12.2 22.5H18.8C19.9201 22.5 20.4802 22.5 20.908 22.282C21.2843 22.0903 21.5903 21.7843 21.782 21.408C22 20.9802 22 20.4201 22 19.3V12.7C22 11.5799 22 11.0198 21.782 10.592C21.5903 10.2157 21.2843 9.90973 20.908 9.71799C20.4802 9.5 19.9201 9.5 18.8 9.5H12.2C11.0799 9.5 10.5198 9.5 10.092 9.71799C9.71569 9.90973 9.40973 10.2157 9.21799 10.592C9 11.0198 9 11.5799 9 12.7V19.3C9 20.4201 9 20.9802 9.21799 21.408C9.40973 21.7843 9.71569 22.0903 10.092 22.282C10.5198 22.5 11.0799 22.5 12.2 22.5Z"
                                            stroke="grey"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </svg>
                                      </span>
                                    </p>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                            <hr className="mt-0" />
                            <div>
                              <Row>
                                <Col lg={5} className="mb-3">
                                  <div className="mb-3">
                                    <h5 className="text-white fw-normal">
                                      Token Price: $
                                      {form[0].PRICE.toFixed(6) || 0}
                                    </h5>
                                    <span className="text-danger">
                                      <span className="downarrow me-1">
                                        {/* <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M22 8L12 18L2 8"
                                          fill="#FF1842"
                                        />
                                      </svg> */}
                                      </span>
                                      {console.log('perr', percentageChange)}
                                      <div
                                        style={{
                                          marginBottom: '20px',
                                          fontSize: '18px',
                                          color: isZero
                                            ? 'gray'
                                            : percentageChange > 0
                                            ? 'green'
                                            : 'red',
                                        }}
                                      >
                                        {isZero
                                          ? '▬'
                                          : percentageChange > 0
                                          ? `▲`
                                          : `▼`}{' '}
                                        Last 24h: {percentageChange}%
                                      </div>
                                    </span>
                                  </div>
                                  <div className="chart">
                                    <div
                                      id="chart"
                                      className="border rounded-1"
                                    >
                                      <div>
                                        <ResponsiveContainer
                                          width="100%"
                                          height={300}
                                        >
                                          <LineChart
                                            key={priceData.length}
                                            data={priceData}
                                            margin={{
                                              top: 20,
                                              right: 30,
                                              left: 20,
                                              bottom: 5,
                                            }}
                                          >
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis
                                              dataKey="time"
                                              tickFormatter={formatTime}
                                            />
                                            <YAxis
                                              domain={[lowerBound, upperBound]}
                                              ticks={ticks}
                                              tickFormatter={(value) =>
                                                value.toFixed(6)
                                              }
                                            />
                                            <Tooltip
                                              formatter={(value) =>
                                                `$${value.toFixed(6)}`
                                              }
                                            />
                                            <Line
                                              type="monotone"
                                              dataKey="price"
                                              stroke="#ff7300"
                                              dot={false}
                                            />
                                          </LineChart>
                                        </ResponsiveContainer>
                                      </div>
                                    </div>
                                    <div id="html-dist"></div>
                                  </div>
                                </Col>
                                <Col lg={7} className="mb-3">
                                  <div>
                                    <h5 className="text-white fw-normal">
                                      Trade
                                    </h5>
                                    {isUsdtFirst ? (
                                      <Col lg={12} className="mb-3">
                                        <div>
                                          <div className="mb-3">
                                            <div className="text-end">
                                              <Form.Text className="text-white">
                                                Balance:{' '}
                                                {parseFloat(
                                                  form[0].BALANCEUSDT
                                                ) || ''}
                                              </Form.Text>
                                            </div>
                                            <InputGroup>
                                              <Form.Control
                                                type="number"
                                                name="UsdtAmount"
                                                value={usdt || ''}
                                                onChange={onchangehandlerUsdt}
                                                placeholder="You Send"
                                                aria-label="You Send"
                                                aria-describedby="basic-addon2"
                                                isInvalid={!!error}
                                              />

                                              <Button
                                                id="button-addon2"
                                                className="bg-transparent"
                                                onClick={(e) => changeCoins(e)}
                                              >
                                                <div className="d-flex align-items-center gap-2">
                                                  <img
                                                    src={`${config.baseUrl}images/usdt.svg`}
                                                    width={`20px`}
                                                    alt=""
                                                  />{' '}
                                                  USDT
                                                </div>
                                              </Button>
                                              <Form.Control.Feedback
                                                type="invalid"
                                                className="text-start"
                                              >
                                                {error}
                                              </Form.Control.Feedback>
                                            </InputGroup>
                                            {form[0].error && (
                                              <div className="text-danger mt-1">
                                                {form[0].error}
                                              </div>
                                            )}
                                          </div>
                                          <div className="mb-3 text-center">
                                            <Button
                                              className="bg-transparent border-0 p-0"
                                              variant="swap"
                                              onClick={(e) => changeCoins(e)}
                                            >
                                              <GrSync />
                                            </Button>
                                          </div>
                                          <div className="mb-3">
                                            <InputGroup>
                                              <Form.Control
                                                type="number"
                                                name={`${form[0].token_name}`}
                                                value={
                                                  form[0].tokenData.Token.toFixed(
                                                    6
                                                  ) || ''
                                                }
                                                placeholder="You Get"
                                                aria-label="You Get"
                                                aria-describedby="basic-addon2"
                                                disabled
                                              />
                                              <Button
                                                id="button-addon2"
                                                className="bg-transparent"
                                                onClick={(e) => changeCoins(e)}
                                              >
                                                <div className="d-flex align-items-center gap-2">
                                                  <img
                                                    src={`${config.imagePath}${form[0].brand_logo}`}
                                                    width="25px"
                                                    alt=""
                                                  />{' '}
                                                  {form[0].token_name}
                                                </div>
                                              </Button>
                                            </InputGroup>
                                            <div className="text-end">
                                              <Form.Text className="text-white">
                                                Balance:{' '}
                                                {parseFloat(
                                                  form[0].BALANCETOKEN
                                                ) || ''}
                                              </Form.Text>
                                            </div>
                                          </div>
                                          <div></div>
                                        </div>
                                        <div className="pricedetail d-flex justify-content-between align-items-end mb-3">
                                          <div>
                                            <div className="small text-light-grey2 mb-2">
                                              <span>Price :</span> 1 :{' '}
                                              {form[0].token_name} ={' '}
                                              <span className="fw-medium">
                                                {form[0].PRICE.toFixed(6)} USDT{' '}
                                              </span>
                                            </div>
                                            <div className="small text-light-grey2 mb-2">
                                              <span>SbSe PFP :</span>{' '}
                                              {form[0].tokenData.Fees.toFixed(
                                                6
                                              ) || ''}{' '}
                                              USDT{' '}
                                            </div>
                                            <div className="small text-light-grey2 mb-2">
                                              <span>
                                                SbSe Trading Rewards :
                                              </span>{' '}
                                              {form[0].tokenData.BuyBack.toFixed(
                                                6
                                              ) || ''}{' '}
                                              USDT{' '}
                                            </div>
                                          </div>
                                        </div>
                                        <Button
                                          className="px-4 rounded-5"
                                          onClick={(e) =>
                                            handleUsdtToTokenSwap(e)
                                          }
                                          disabled={
                                            !usdt || !!form[0].error || error
                                          }
                                        >
                                          {' '}
                                          SWAP
                                        </Button>
                                      </Col>
                                    ) : (
                                      <>
                                        {form.length > 0 && (
                                          <>
                                            <Col lg={12} className="mb-3">
                                              <div>
                                                <div className="mb-3">
                                                  <div className="text-end">
                                                    <Form.Text className="text-white">
                                                      Balance:{' '}
                                                      {parseFloat(
                                                        form[0].BALANCETOKEN
                                                      ) || ''}
                                                    </Form.Text>
                                                  </div>
                                                  <InputGroup>
                                                    <Form.Control
                                                      type="number"
                                                      name="TokenAmount"
                                                      value={token || ''}
                                                      onChange={
                                                        onchangehandlerToken
                                                      }
                                                      placeholder="You Send"
                                                      aria-label="You Send"
                                                      aria-describedby="basic-addon2"
                                                      isInvalid={!!error}
                                                    />
                                                    <Button
                                                      id="button-addon2"
                                                      className="bg-transparent"
                                                      onClick={(e) =>
                                                        changeCoins(e)
                                                      }
                                                    >
                                                      <div className="d-flex align-items-center gap-2">
                                                        <img
                                                          src={`${config.imagePath}${form[0].brand_logo}`}
                                                          width="25px"
                                                          alt=""
                                                        />{' '}
                                                        {form[0].token_name}
                                                      </div>
                                                    </Button>
                                                    <Form.Control.Feedback
                                                      type="invalid"
                                                      className="text-start"
                                                    >
                                                      {error}
                                                    </Form.Control.Feedback>
                                                  </InputGroup>
                                                  {form[0].error && (
                                                    <div className="text-danger mt-1">
                                                      {form[0].error}
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                              <div className="mb-3 text-center">
                                                <Button
                                                  className="bg-transparent border-0 p-0"
                                                  variant="swap"
                                                  onClick={(e) =>
                                                    changeCoins(e)
                                                  }
                                                >
                                                  <GrSync />
                                                </Button>
                                              </div>
                                              <InputGroup>
                                                <Form.Control
                                                  type="number"
                                                  name="UsdtAmount"
                                                  value={
                                                    form[0].usdtData.USDT.toFixed(
                                                      6
                                                    ) || ''
                                                  }
                                                  placeholder="You Get"
                                                  aria-label="You Get"
                                                  aria-describedby="basic-addon2"
                                                  disabled
                                                  className=""
                                                />
                                                <Button
                                                  id="button-addon2"
                                                  className="bg-transparent"
                                                  onClick={(e) =>
                                                    changeCoins(e)
                                                  }
                                                >
                                                  <div className="d-flex align-items-center gap-2">
                                                    <img
                                                      src={`${config.baseUrl}images/usdt.svg`}
                                                      width={`20px`}
                                                      alt=""
                                                    />{' '}
                                                    USDT
                                                  </div>
                                                </Button>
                                              </InputGroup>
                                              <div className="text-end">
                                                <Form.Text className="text-white">
                                                  Balance:{' '}
                                                  {parseFloat(
                                                    form[0].BALANCEUSDT
                                                  ) || ''}
                                                </Form.Text>
                                              </div>
                                            </Col>

                                            <div className="pricedetail ">
                                              <div className="small text-light-grey2 mb-2  me-4">
                                                SbSe Reserve:{' '}
                                                <span className="fw-medium">
                                                  {' '}
                                                  {form[0].usdtData.SbSeReserve.toFixed(
                                                    6
                                                  ) || ''}{' '}
                                                  USDT
                                                </span>
                                              </div>
                                              <div className="small text-light-grey2 mb-2 me-4">
                                                SbSe Trading Rewards:{' '}
                                                <span className="fw-medium">
                                                  {form[0].usdtData.BuyBack.toFixed(
                                                    6
                                                  ) || ''}{' '}
                                                  USDT
                                                </span>{' '}
                                              </div>
                                              {toTreasury ? (
                                                <>
                                                  <div className="small text-light-grey2 mb-2 me-4">
                                                    SbSe Treasury:{' '}
                                                    <span className="fw-medium">
                                                      {' '}
                                                      {form[0].usdtData.ToTreasuryOrPool.toFixed(
                                                        6
                                                      ) || ''}{' '}
                                                      USDT{' '}
                                                    </span>{' '}
                                                  </div>
                                                  <div className="small text-light-grey2 mb-2 me-4">
                                                    SbSe PFP:{' '}
                                                    <span className="fw-medium">
                                                      {' '}
                                                      {form[0].usdtData.AmountToSbse.toFixed(
                                                        6
                                                      ) || ''}{' '}
                                                      USDT{' '}
                                                    </span>
                                                  </div>
                                                </>
                                              ) : (
                                                <div className="small text-light-grey2 mb-2 d-inline-block">
                                                  SbSe PFP:{' '}
                                                  <span className="fw-medium">
                                                    {' '}
                                                    {(
                                                      form[0].usdtData
                                                        .ToTreasuryOrPool +
                                                      form[0].usdtData
                                                        .AmountToSbse
                                                    ).toFixed(6) || ''}{' '}
                                                    USDT{' '}
                                                  </span>
                                                </div>
                                              )}
                                            </div>
                                            <div className="d-flex align-items-center mb-3 switchBtn">
                                              <div className="me-2 mb-1">
                                                Send to Treasury
                                              </div>
                                              <Form>
                                                <Form.Check
                                                  type="switch"
                                                  id="custom-switch"
                                                  checked={toTreasury}
                                                  onChange={handleToggle}
                                                />
                                              </Form>
                                            </div>
                                            <Button
                                              className="px-4 rounded-5"
                                              onClick={(e) =>
                                                handleTokenToUsdtSwap(e)
                                              }
                                              disabled={
                                                !token ||
                                                !!form[0].error ||
                                                error
                                              }
                                            >
                                              {' '}
                                              SWAP
                                            </Button>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    )}
                    <Col
                      xxl={3}
                      xl={3}
                      lg={12}
                      md={12}
                      sm={12}
                      className="mb-4"
                    >
                      <Card className="dashboard-card box-gradient p-3 d-flex overflow-hidden gap-3 bgparticle mb-3">
                        <Card.Body className="">
                          <div className="d-flex gap-3 justify-content-center align-items-center position-relative">
                            <div className="text-center">
                              <div className="mb-2">
                                <span className="SbSeIcon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="40"
                                    height="40"
                                    viewBox="0 0 64 60"
                                    fill="none"
                                  >
                                    <path
                                      d="M4.91484 37.1137L16.795 30.2547L28.6751 37.1137V50.8317L16.795 57.6907L4.91484 50.8317V37.1137Z"
                                      stroke="white"
                                      stroke-width="4"
                                    />
                                    <path
                                      d="M35.326 37.1137L47.2061 30.2547L59.0862 37.1137V50.8317L47.2061 57.6907L35.326 50.8317V37.1137Z"
                                      stroke="white"
                                      stroke-width="4"
                                    />
                                    <path
                                      d="M21.3533 9.1684L33.2335 2.3094L45.1136 9.1684V22.8864L33.2335 29.7454L21.3533 22.8864V9.1684Z"
                                      stroke="white"
                                      stroke-width="4"
                                    />
                                  </svg>
                                </span>
                              </div>
                              <h5 className="text-white lh-base">
                                SbSe Protocol
                              </h5>
                            </div>
                          </div>
                        </Card.Body>
                        <div
                          className="bottom position-absolute top-0 start-0 bottom-0
                      end-0"
                        >
                          <img
                            src={`${config.baseUrl}images/dashboard/shape/ellipseCard.svg`}
                            width={`100%`}
                            height={`100%`}
                            alt=""
                          />
                        </div>
                      </Card>
                      <Card className="dashboard-card box-gradient p-3 d-flex overflow-hidden gap-3 bgparticle mb-3">
                        <Card.Body className="">
                          <div className=" d-flex gap-3 justify-content-center align-items-center">
                            <div className="text-center">
                              <div className="mb-2">
                                <span className="SbSeIcon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="40"
                                    height="40"
                                    viewBox="0 0 52 63"
                                    fill="none"
                                  >
                                    <path
                                      d="M22.9266 38.2183C20.0264 36.9753 16.6609 36.7213 14.4471 36.8681C13.8523 36.9076 13.3117 36.4678 13.2833 35.8723L13.1785 33.6705C13.1407 32.8769 12.2372 32.4422 11.5935 32.9078L2.68197 39.3544C2.12194 39.7596 2.13198 40.5971 2.70156 40.9887L11.77 47.2232C12.4335 47.6794 13.3365 47.2044 13.3365 46.3992V44.874C13.3365 44.3217 13.784 43.874 14.3363 43.874C16.0184 43.874 18.5347 43.874 19.9758 43.874C21.6871 43.874 22.6173 45.8649 22.8996 46.9603C22.9185 47.0336 22.9266 47.1089 22.9266 47.1846V60.333C22.9266 60.8853 23.3744 61.333 23.9266 61.333H28.566C29.1183 61.333 29.566 60.8853 29.566 60.333V45.1035M22.9266 38.2183C26.1234 39.4478 28.8283 42.8904 29.566 45.1035M22.9266 38.2183V14.7833C22.9266 14.2677 22.5347 13.8367 22.0215 13.7878L19.4903 13.5467C18.7233 13.4737 18.3235 12.597 18.7714 11.97L25.5555 2.47223C25.9544 1.91389 26.7842 1.91389 27.183 2.47223L33.8464 11.801C34.3191 12.4628 33.846 13.3822 33.0326 13.3822H30.566C30.0137 13.3822 29.566 13.8299 29.566 14.3822V23.956M29.566 45.1035V33.3002M29.566 23.956C30.835 23.4334 34.1165 22.5165 37.8128 22.6542C38.4021 22.6762 38.9103 22.2164 38.9103 21.6267V19.7324C38.9103 18.9227 39.8222 18.4487 40.4849 18.914L49.3193 25.1169C49.8816 25.5117 49.8875 26.3429 49.3308 26.7456L40.4964 33.1364C39.8351 33.6148 38.9103 33.1423 38.9103 32.3262V30.3658C38.9103 29.8135 38.4625 29.3658 37.9103 29.3658H34.9758C32.025 29.3658 29.7627 30.9396 29.566 33.3002M29.566 23.956V33.3002"
                                      stroke="white"
                                      stroke-width="3"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </span>
                              </div>
                              <h5 className="text-white lh-base">
                                SbSe Reserve
                              </h5>
                            </div>
                          </div>
                        </Card.Body>
                        <div
                          className="bottom position-absolute top-0 start-0 bottom-0
                      end-0"
                        >
                          <img
                            src={`${config.baseUrl}images/dashboard/shape/ellipseCard.svg`}
                            width={`100%`}
                            height={`100%`}
                            alt=""
                          />
                        </div>
                      </Card>
                      <Card className="dashboard-card box-gradient p-3 d-flex overflow-hidden gap-3 bgparticle">
                        <Card.Body className="">
                          <div className=" d-flex gap-3 justify-content-center align-items-center">
                            <div className="text-center">
                              <div className="mb-2">
                                <span className="SbSeIcon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="40"
                                    height="40"
                                    viewBox="0 0 51 57"
                                    fill="none"
                                  >
                                    <path
                                      d="M38.4996 2.66699L48.8996 13.067M48.8996 13.067L38.4996 23.467M48.8996 13.067H14.5796C10.2112 13.067 8.02699 13.067 6.35848 13.9171C4.89082 14.665 3.69757 15.8582 2.94976 17.3259C2.09961 18.9944 2.09961 21.1786 2.09961 25.547V26.067M2.09961 44.267H36.4196C40.788 44.267 42.9722 44.267 44.6407 43.4168C46.1084 42.669 47.3016 41.4758 48.0495 40.0081C48.8996 38.3396 48.8996 36.1554 48.8996 31.787V31.267M2.09961 44.267L12.4996 54.667M2.09961 44.267L12.4996 33.867"
                                      stroke="white"
                                      stroke-width="4"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </span>
                              </div>
                              <h5 className="text-white lh-base">
                                USDT Rewards
                              </h5>
                            </div>
                          </div>
                        </Card.Body>
                        <div
                          className="bottom position-absolute top-0 start-0 bottom-0
                      end-0"
                        >
                          <img
                            src={`${config.baseUrl}images/dashboard/shape/ellipseCard.svg`}
                            width={`100%`}
                            height={`100%`}
                            alt=""
                          />
                        </div>
                      </Card>
                    </Col>
                  </Row>
                )}
              </div>
              <DashboardFooter />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Swap;
